import React, { useEffect, useState } from "react";
import { useDispatch, useSelector, useMiniGameAuth } from "@pages/Events/MiniGame/store";
import {
  changeAttemptByBidMiniGame,
  getDataSpinUserMiniGame,
  setDataPopupError,
  setDataSpinLeft,
  setOpenPopupChangeCoinsSuccess,
  setOpenPopupFooter,
} from "../../../../../Redux/futures/mini-game/action";
import iconHeader from "../../../../../assets/images/Mini-Game/icon-head-popup.png";
import { curStateMiniGame } from "../../../../../Redux/selector";
import PopupFooter from ".";
import styled from "styled-components";
import bgHeader from "../../../../../assets/images/Mini-Game/header-mission.png";
import MissionEarnCoins from "./components/MissionEarnCoins";
import ChangeCoins from "./components/ChangeCoins";
import PopupCongratula from "./PopupCongratula";
import { getTurnRemain } from "../../../../../Redux/futures/account/actions";
import _ from "lodash";
import { useTranslation } from "react-i18next";
import PopupChangeCoin from "../PopupChangeCoin/PopupChangeCoin";

export default function PopupEarnMore({
  isPopupNoCoins,
  isMissionMini = false,
  // missionMiniClick = () => {},
  onCancel = () => { },
  className,
  isPopupToRell = false,
  turn,
  setTurn,
  setOpenPopupChangeCoin,
}) {
  const dataMiniGame = useSelector(curStateMiniGame);
  const [step, setStep] = useState("earn more");
  const [isLoadingApi, setIsLoadingApi] = useState(false);
  const { isAuthenticated, requireLogin } = useMiniGameAuth();
  const { t } = useTranslation();

  useEffect(() => {
    if (dataMiniGame?.popupEarnMore?.turn) {
      setTurn(dataMiniGame?.popupEarnMore?.turn);
    }
  }, [dataMiniGame?.popupEarnMore?.turn]);
  const dispatch = useDispatch();

  useEffect(() => {
    setStep(dataMiniGame?.popupEarnMore?.step || "earn more");
  }, [dataMiniGame?.popupEarnMore?.step]);

  const handleClosePopupFooter = () => {
    dispatch(
      setOpenPopupFooter({
        isShowPopup: false,
        step: null,
      }),
    );
  };
  const buttonAction = (type = "add") => {
    if (!isAuthenticated) {
      requireLogin();
      return;
    }
    if (type == "add") {
      return setTurn((prev) => prev + 1);
    }

    if (turn == 1) {
      return null;
    }

    setTurn((prev) => prev - 1);
  };

  const afterChangeBid = (data, isLoading, dataError) => {
    if (!isLoading) {
      if (data && data?.success) {
        setIsLoadingApi(false);
        dispatch(
          setOpenPopupChangeCoinsSuccess({
            isShowPopupChangeCoinsSuccess: true,
            totalCoins: turn,
          }),
        );
        dispatch(getTurnRemain({}));
        dispatch(getDataSpinUserMiniGame());
        dispatch(
          setOpenPopupFooter({
            isShowPopup: false,
            step: "",
            turn: 0,
            isMiniPrizeCollection: false,
          }),
        );
      } else {
        setIsLoadingApi(false);
        dispatch(
          setDataPopupError({
            isOpen: true,
            message: dataError?.errorMessage || data?.message || "",
          }),
        );
      }
    }
  };

  const handleConfirm = () => {
    if (isLoadingApi) {
      return;
    }
    setIsLoadingApi(true);
    setStep("congratula");
    onCancel();
    dispatch(
      changeAttemptByBidMiniGame({
        callback: afterChangeBid,
        bid_number: turn,
      }),
    );
  };

  if (!dataMiniGame?.popupEarnMore?.isShowPopup && isMissionMini === false && !isPopupToRell) {
    return null;
  }

  const missionMiniClick = () => {
    dispatch(
      setOpenPopupFooter({
        isShowPopup: true,
        step: "change Coins",
        turn: turn,
        isMiniPrizeCollection: true,
      }),
    );
  };

  if (isMissionMini) {
    return (
      <Container className={className}>
        <div className="container-popup-mini-rule">
          <MissionEarnCoins
            setStep={setStep}
            turn={turn}
            buttonAction={buttonAction}
            missionMiniClick={missionMiniClick}
            setOpenPopupChangeCoin={setOpenPopupChangeCoin}
            setTurn={setTurn}
          />
          {step === "change Coins" ? (
            <></>
            // <PopupFooter
            //   isOpen={dataMiniGame?.popupEarnMore?.isShowPopup}
            //   onClose={handleClosePopupFooter}
            //   className="minigame-popup-earn"
            //   isGetContainer={false}
            //   srcImgHeader={iconHeader}
            // >
            //   <ChangeCoins handleConfirm={handleConfirm} setStep={setStep} turn={turn} />
            // </PopupFooter>
          ) : null}
        </div>
      </Container>
    );
  }

  return (
    <Container>
      {isPopupNoCoins ? (
        <>
          {step !== "congratula" ? (
            <div>
              <div className="">
                {step === "earn more" ? (
                  <>
                    <MissionEarnCoins
                      setStep={setStep}
                      turn={turn}
                      buttonAction={buttonAction}
                      isSmall
                      onCancel={onCancel}
                      setOpenPopupChangeCoin={setOpenPopupChangeCoin}
                      setTurn={setTurn}
                    />
                  </>
                ) : (
                  <></>
                  // <ChangeCoins
                  //   handleConfirm={handleConfirm}
                  //   setStep={setStep}
                  //   turn={turn || dataMiniGame?.popupEarnMore?.turn}
                  //   isNoMoreCoins
                  // />
                )}
              </div>
            </div>
          ) : null}
        </>
      ) : (
        <>
          {step !== "congratula" ? (
            <PopupFooter
              isOpen={dataMiniGame?.popupEarnMore?.isShowPopup}
              onClose={handleClosePopupFooter}
              className="minigame-popup-earn"
              isGetContainer={false}
              srcImgHeader={iconHeader}
            >
              <div className="container-popup-mini-rule">
                <div className="header-mini-popup-rule">
                  <img src={bgHeader} alt="" className="img-rule-mini" />
                  <div className="content-rule-mini content-rule-mini-change-coins">
                    {step === "earn more"
                      ? t("mini_game.pop_up_earn_more.title")
                      : t("mini_game.standard_missions.change_coins")}
                  </div>
                </div>
                {step === "earn more" ? (
                  <MissionEarnCoins setStep={setStep} turn={turn} buttonAction={buttonAction} />
                ) : (
                  <ChangeCoins handleConfirm={handleConfirm} setStep={setStep} turn={turn} />
                )}
              </div>
            </PopupFooter>
          ) : null}
        </>
      )}

    </Container>
  );
}

const Container = styled.div`
  .container-popup-mini-rule {
    margin-top: 35px;
  }

  .ant-drawer-mask {
    position: fixed;
  }

  /* .ant-modal {
      top: 50% !important;
      transform: translateY(-50%);
    } */

  .ant-drawer {
    z-index: 101;
  }
  .minigame-popup-earn {
    .content-rule-mini {
      font-size: 26px;
    }
    .popup-minigame__2025,
    .popup-minigame__2025__drawer {
      .bg-rule-mini-top {
        top: -5% !important;
        left: 50% !important;
        transform: translate(-50%, -50%) !important;
        height: auto !important;
      }
      /* top: -112px; */
    }
  }

  @media screen and (max-width: 768px) and (min-width: 500px) {
    .container-popup-mini-rule {
      width: 90%;
      margin: 0 auto;
    }
  }

  @media (max-width: 500px) {
    .container-popup-mini-rule {
      margin: 0 -25px;
    }
  }
`;
